import React from "react";
import styles from "./skeleton.module.css";

const ResponseSkeleton: React.FC = () => {
  return (
    <div className={styles.skeletonContainer}>
      {/* Summary Skeleton */}
      <div className={styles.summarySection}>
        <div className={styles.skeletonLine} style={{ width: "90%" }}></div>
        <div className={styles.skeletonLine} style={{ width: "75%" }}></div>
      </div>

      {/* Answer Skeleton */}
      <div className={styles.answerSection}>
        <div className={styles.skeletonLine} style={{ width: "95%" }}></div>
        <div className={styles.skeletonLine} style={{ width: "88%" }}></div>
        <div className={styles.skeletonLine} style={{ width: "92%" }}></div>
        <div className={styles.skeletonLine} style={{ width: "80%" }}></div>
      </div>

      {/* Related Info Skeleton */}
      <div className={styles.relatedInfoSection}>
        <div className={styles.skeletonLine} style={{ width: "85%" }}></div>
        <div className={styles.skeletonLine} style={{ width: "78%" }}></div>
      </div>

      {/* Follow-ups Skeleton */}
      <div className={styles.followupsSection}>
        <div className={styles.skeletonLine} style={{ width: "70%" }}></div>
        <div className={styles.skeletonLine} style={{ width: "65%" }}></div>
      </div>
    </div>
  );
};

export default ResponseSkeleton;
